import posthog from 'posthog-js'

const CAL_BOOKING_URL =
  'https://cal.com/team/lightstrike-labs-sales/productneedsdiagnosis'

const POSTHOG_API_KEY = process.env.VITE_PUBLIC_POSTHOG_KEY ?? ''
const POSTHOG_HOST = process.env.VITE_PUBLIC_POSTHOG_HOST ?? 'https://us.i.posthog.com'

let posthogInitialized = false

export function initAnalytics() {
  if (POSTHOG_API_KEY && !posthogInitialized) {
    posthog.init(POSTHOG_API_KEY, {
      api_host: POSTHOG_HOST,
      capture_pageview: true,
      capture_pageleave: true,
    })
    posthogInitialized = true
  }
}

// --- GTM dataLayer helper ---
// Cal.com's native GTM integration fires `bookingSuccessfulV2` on the
// booking page itself. These helpers track CTA interactions on *our* site
// so you can build a full funnel (site visit → CTA click → booking).

function pushToDataLayer(event: string, data?: Record<string, unknown>) {
  const w = window as typeof window & { dataLayer?: Record<string, unknown>[] }
  w.dataLayer = w.dataLayer || []
  w.dataLayer.push({ event, ...data })
}

// --- Event helpers ---

type CtaLocation = 'Hero' | 'ValueStack' | 'SecondaryCta' | 'Footer' | 'CoachingOnboardComplete' | 'CoachingEngineering' | 'CoachingFullProject' | 'CoachingBottomCta'

export function trackCtaSelected(location: CtaLocation) {
  posthog.capture('CtaSelected', {
    Location: location,
    Destination: CAL_BOOKING_URL,
  })

  pushToDataLayer('CtaSelected', {
    Location: location,
    Destination: CAL_BOOKING_URL,
  })
}

export function openBookingPage(location: CtaLocation) {
  trackCtaSelected(location)
  window.open(CAL_BOOKING_URL, '_blank', 'noopener,noreferrer')
}

// --- Deck analytics events ---

export function trackDeckCodeVerified(workshopSlug: string, success: boolean) {
  posthog.capture('DeckCodeVerified', {
    WorkshopSlug: workshopSlug,
    Success: success,
  })
  pushToDataLayer('DeckCodeVerified', {
    WorkshopSlug: workshopSlug,
    Success: success,
  })
}

export function trackDeckViewed(workshopSlug: string, deckType: string) {
  posthog.capture('DeckViewed', {
    WorkshopSlug: workshopSlug,
    DeckType: deckType,
  })
  pushToDataLayer('DeckViewed', {
    WorkshopSlug: workshopSlug,
    DeckType: deckType,
  })
}

export function trackSlideViewed(workshopSlug: string, slideIndex: number, slideLayout: string) {
  posthog.capture('SlideViewed', {
    WorkshopSlug: workshopSlug,
    SlideIndex: slideIndex,
    SlideLayout: slideLayout,
  })
}

export function trackDeckCompleted(workshopSlug: string, deckType: string, durationMs: number) {
  posthog.capture('DeckCompleted', {
    WorkshopSlug: workshopSlug,
    DeckType: deckType,
    DurationMs: durationMs,
  })
  pushToDataLayer('DeckCompleted', {
    WorkshopSlug: workshopSlug,
    DeckType: deckType,
    DurationMs: durationMs,
  })
}
